/**
 * Build-time flags (docs/tech/implementation-tasks.md §4). Code that must be *physically absent* from a build
 * (debug hooks, donation) should test the raw `__FEATURE_*__` constant so the minifier removes the branch.
 */
export const features = {
  donation: __FEATURE_DONATION__,
  debugTools: __FEATURE_DEBUG_TOOLS__,
  pwa: __FEATURE_PWA__,
  /** The web build links to a signed APK in /download/ (scripts/release-android.ts). */
  androidApk: __FEATURE_ANDROID_APK__,
} as const;

export const platformKind = __PLATFORM__;
export const appVersion = __APP_VERSION__;
export const appBuild = __APP_BUILD__;
